import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const CTASection = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    console.log("Get  clicked");
  };

  const handleViewServices = () => {
    navigate("/services");
  };

  return (
    <div className="bg-gradient-to-br from-primary via-secondary to-accent rounded-xl shadow-2xl p-6 md:p-8 lg:p-12 text-center">
      <div className="max-w-3xl mx-auto">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mx-auto mb-4 md:mb-6">
          <Icon name="Rocket" size={32} color="#ffffff" />
        </div>

        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 md:mb-4 font-heading">
          Ready to Write Your Success Story?
        </h2>

        <p className="text-sm md:text-base lg:text-lg text-white/90 mb-6 md:mb-8 lg:mb-10 max-w-2xl mx-auto">
          Join 196+ satisfied clients who have transformed their businesses with
          our integrated IT and branding solutions. Let's create measurable
          results together.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-6 md:mb-8">
          <Button
            variant="default"
            size="lg"
            onClick={handleGetStarted}
            iconName="ArrowRight"
            iconPosition="right"
            className="bg-white text-primary hover:bg-white/90 w-full sm:w-auto"
          >
            Start Your Project
          </Button>
          <Button
            variant="outline"
            size="lg"
            onClick={handleViewServices}
            iconName="Briefcase"
            iconPosition="left"
            className="border-white text-white hover:bg-white/10 w-full sm:w-auto"
          >
            Explore Services
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 pt-6 md:pt-8 border-t border-white/20">
          <div className="text-center">
            <div className="flex items-center justify-center gap-2 mb-2">
              <Icon name="Clock" size={20} color="#ffffff" />
              <span className="text-white font-semibold text-sm md:text-base">
                24/7 Support
              </span>
            </div>
            <p className="text-xs md:text-sm text-white/80">
              Always available for you
            </p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center gap-2 mb-2">
              <Icon name="Award" size={20} color="#ffffff" />
              <span className="text-white font-semibold text-sm md:text-base">
                13+ Years
              </span>
            </div>
            <p className="text-xs md:text-sm text-white/80">
              Industry expertise
            </p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center gap-2 mb-2">
              <Icon name="TrendingUp" size={20} color="#ffffff" />
              <span className="text-white font-semibold text-sm md:text-base">
                95% Success
              </span>
            </div>
            <p className="text-xs md:text-sm text-white/80">
              Proven track record
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
